import Plot from "react-plotly.js";
import { useMemo } from "react";
import { premiumLayout, premiumConfig, premiumPalette } from "./plotTheme";

function safeArray(x) {
  return Array.isArray(x) ? x : [];
}

export default function BarPlot({ title = "", items }) {
  const safeItems = safeArray(items);

  const { x, y } = useMemo(() => {
    const xs = [];
    const ys = [];
    for (const it of safeItems) {
      const lx = it?.label ?? it?.name ?? it?.key ?? it?.category ?? "";
      const vy = it?.count ?? it?.value ?? it?.y ?? 0;
      if (!lx) continue;
      xs.push(lx);
      ys.push(Number(vy) || 0);
    }
    return { x: xs, y: ys };
  }, [safeItems]);

  const data = useMemo(
    () => [
      {
        type: "bar",
        x,
        y,
        marker: { color: premiumPalette.yes, opacity: 0.92 },
        hovertemplate: "<b>%{x}</b><br>%{y}<extra></extra>",
      },
    ],
    [x, y]
  );

  const layout = useMemo(() => {
    const L = premiumLayout();
    return {
      ...L,
      height: 340,
      margin: { l: 52, r: 14, t: 10, b: 90 },
      xaxis: {
        ...L.xaxis,
        automargin: true,
        tickangle: -20,
      },
      yaxis: {
        ...L.yaxis,
        rangemode: "tozero",
      },
      showlegend: false,
    };
  }, []);

  return (
    <div className="min-w-0 rounded-2xl border border-slate-200/70 bg-white shadow-[0_1px_0_rgba(15,23,42,0.04),0_8px_24px_rgba(15,23,42,0.08)] p-4">
      <div className="text-sm font-semibold text-slate-900">{title}</div>
      <div className="min-w-0 mt-2">
        <Plot
          data={data}
          layout={layout}
          config={premiumConfig}
          useResizeHandler
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}